export default __webpack_public_path__ + "static/210526_妲絲刷關活動熱更完成_kr-06c575ad49cc9e6aeb6f4d6f5b04e045.png";